import { useRouter } from "next/router";

const useIsAtHomePage = () => {
  const { asPath } = useRouter();
  return asPath.includes("/home/");
};

export default useIsAtHomePage;
